"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import type { ColorBlockProps, ColorBlockVariant, VariantProps } from "./color-block.types";
import { SquareColorBlock } from "./variants/square/square";
import { SquareShapeColorBlock } from "./variants/square-shape/square-shape";
import { RectangleSmColorBlock } from "./variants/rectangle-sm/rectangle-sm";
import { RectangleLgColorBlock } from "./variants/rectangle-lg/rectangle-lg";
import { RectangleXlColorBlock } from "./variants/rectangle-xl/rectangle-xl";
import { RectangleSmMobileColorBlock } from "./variants/rectangle-sm-mobile/rectangle-sm-mobile";
import { RectangleMdMobileColorBlock } from "./variants/rectangle-md-mobile/rectangle-md-mobile";
import { RectangleLgMobileColorBlock } from "./variants/rectangle-lg-mobile/rectangle-lg-mobile";
import { RectangleXlMobileColorBlock } from "./variants/rectangle-xl-mobile/rectangle-xl-mobile";
const variantMap: Record<ColorBlockVariant, React.ForwardRefExoticComponent<VariantProps & React.RefAttributes<HTMLDivElement>>> = {
  square: SquareColorBlock,
  "square-shape": SquareShapeColorBlock,
  "rectangle-sm": RectangleSmColorBlock,
  "rectangle-lg": RectangleLgColorBlock,
  "rectangle-xl": RectangleXlColorBlock,
  "rectangle-sm-mobile": RectangleSmMobileColorBlock,
  "rectangle-md-mobile": RectangleMdMobileColorBlock,
  "rectangle-lg-mobile": RectangleLgMobileColorBlock,
  "rectangle-xl-mobile": RectangleXlMobileColorBlock
};
const ColorBlock = React.forwardRef<HTMLDivElement, ColorBlockProps>((t0, ref) => {
  const $ = _c(15);
  let children;
  let className;
  let color;
  let props;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      variant,
      color,
      animated: t1,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = color;
    $[4] = props;
    $[5] = t1;
    $[6] = variant;
  } else {
    children = $[1];
    className = $[2];
    color = $[3];
    props = $[4];
    t1 = $[5];
    variant = $[6];
  }
  const animated = t1 === undefined ? true : t1;
  const VariantComponent = variantMap[variant];
  let t2;
  if ($[7] !== VariantComponent || $[8] !== animated || $[9] !== children || $[10] !== className || $[11] !== color || $[12] !== props || $[13] !== ref) {
    t2 = <VariantComponent ref={ref} color={color} animated={animated} className={className} {...props}>{children}</VariantComponent>;
    $[7] = VariantComponent;
    $[8] = animated;
    $[9] = children;
    $[10] = className;
    $[11] = color;
    $[12] = props;
    $[13] = ref;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
});
ColorBlock.displayName = "ColorBlock";
export { ColorBlock };